/**
 * 判断是否为原生 Google Chrome 浏览器并获取版本号
 * @returns {Object} { isChrome: Boolean, version: String|null }
 */
export function getNativeChromeInfo() {
  // 获取浏览器用户代理字符串
  const userAgent = navigator.userAgent.toLowerCase();

  // 1. 基础判断：包含 chrome 关键字
  const hasChrome = userAgent.includes('chrome');
  // 2. 排除 Edge/Edge Chromium（微软浏览器）
  const isEdge = userAgent.includes('edge') || userAgent.includes('edg');
  // 3. 排除 360、QQ、搜狗等国产套壳浏览器（特征关键字）
  const isOtherBrowser = /360|qq|sogou|liebao|maxthon|ucbrowser/.test(userAgent);

  // 最终判定：原生谷歌浏览器
  const isNativeChrome = hasChrome && !isEdge && !isOtherBrowser;

  // 获取 Chrome 版本号
  let version = null;
  if (isNativeChrome) {
    // 正则匹配版本号
    const versionMatch = userAgent.match(/chrome\/(\d+)/);
    version = versionMatch ? versionMatch[1] : null;
  }

  return {
    isChrome: isNativeChrome,
    version: version
  };
}